'use client';

import { sendGTMEvent } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

import { Link, type LinkProps } from '@natu/next-link';
import type { PredefinedGAEvents } from '@natu/utils/events';
import { getEventPayload } from '@natu/utils/getEventPayload';
import { usePageContext } from '@natu/utils/PageContextProvider';

interface LinkWithEventProps {
  children: ReactNode;
  className: string;
  link: LinkProps;
  event: PredefinedGAEvents;
}

export const LinkWithEvent = ({
  children,
  className,
  link,
  event,
  ...rest
}: LinkWithEventProps) => {
  const pathname = usePathname();
  const { isCampaign } = usePageContext() || {};
  const eventPayload = getEventPayload({ pathname, event, isCampaign });

  return (
    <Link
      {...link}
      className={className}
      onClick={() => sendGTMEvent({ event, ...eventPayload })}
      {...rest}
    >
      {children}
    </Link>
  );
};
